import { frCA } from "../../../../date-fns/locale/fr-CA.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    frCA
  }
};